import * as types from './types'

const getTahunConfig_act = () => async (dispatch, getState, Api) => {
    dispatch({ type: types.GET_TAHUNCONFIG_START })
    const response = await Api.getTahunConfig();
    if (response.status !== "failed") {
        dispatch({ type: types.GET_TAHUNCONFIG_SUCCESS, payload: response.data })
    } else {
        dispatch({ type: types.GET_TAHUNCONFIG_FAILED, payload: response.error })
    }
    return response
}

export { getTahunConfig_act }